module.exports = __webpack_public_path__ + "static/media/admin.c5455b1a.svg";